import React from 'react';
import { Card, Badge, Button } from 'react-bootstrap';
import { FaStar, FaRegStar, FaUser, FaEye } from 'react-icons/fa';
import './FeedbackReportCard.css';

const FeedbackReportCard = ({ feedback, onOpen, onMarkAsRead, users }) => {
    const formatDate = (timestamp) => {
        if (!timestamp) return 'N/A';

        let date;
        // Handle Firestore Timestamp
        if (timestamp.toDate) {
            date = timestamp.toDate();
        }
        // Handle JavaScript Date
        else if (timestamp instanceof Date) {
            date = timestamp;
        }
        // Handle timestamp in seconds
        else if (typeof timestamp === 'number') {
            date = new Date(timestamp);
        }
        else {
            return 'N/A';
        }

        const day = String(date.getDate()).padStart(2, '0');
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const year = date.getFullYear();
        const hours = String(date.getHours()).padStart(2, '0');
        const minutes = String(date.getMinutes()).padStart(2, '0');

        return `${day}/${month}/${year} ${hours}:${minutes}`;
    };

    const renderStars = (score) => {
        return Array(5).fill(0).map((_, index) => (
            index < score ? <FaStar key={index} className="feedback-report-star-icon filled" /> : <FaRegStar key={index} className="feedback-report-star-icon" />
        ));
    };
    const user = users.find(u => u.userId === feedback.userId);

    return (
        <Card className={`feedback-report-card ${feedback.wasRead ? 'read' : 'unread'}`}>
            <Card.Body className="d-flex justify-content-between align-items-center p-2">
                <div className="d-flex align-items-center gap-3">
                    <div className="feedback-report-user-info">
                        <FaUser className="feedback-report-user-icon" />
                        <div className="feedback-report-user-details">
                            <div className="feedback-report-user-id">UID: {feedback.userId}</div>
                            <div className="feedback-report-user-name">שם: {user?.userName || 'לא צוין'}</div>
                            <div className="feedback-report-user-email">אימייל: {user?.userEmailAddress || 'לא צוין'}</div>
                        </div>
                    </div>
                    <div className="feedback-report-stars-container">
                        {renderStars(feedback.satisfactionScore)}
                    </div>
                    {!feedback.wasRead && (
                        <Badge bg="danger" className="ms-2">
                            חדש
                        </Badge>
                    )}
                </div>
                <div className="d-flex align-items-center gap-2">
                    <div className="feedback-report-timestamp">
                        {formatDate(feedback.feedbackTimestamp)}
                    </div>
                    <Button
                        variant="outline-primary"
                        size="sm"
                        onClick={() => onOpen(feedback)}
                        className="feedback-report-view-button"
                    >
                        <FaEye className="me-1" />
                        צפייה
                    </Button>
                </div>
            </Card.Body>
        </Card>
    );
};

export default FeedbackReportCard; 